import { default as apiAction, multipleRequestApiAction } from '@ynap/api-fetch-action';
import { redirectToLogin } from '@ynap/redirect-utils';
import { notificationActions } from '@ynap/notification-state';
import getMessages from '../selectors/getMessages';
import { NOT_AUTHORISED_ERROR, NO_UBER_TOKEN_ERROR, FETCH_NAVIGATION_PREFIX } from '../constants';

export function apiRequest(request, PREFIX, options = {}) {
    return (dispatch) => {
        return dispatch(apiAction(request, PREFIX, null, options));
    };
}

/**
 * The goal of this function is to display a Notification telling the user
 * authentication is required in order to add an item to a wishlist
 * @param {STRING} PREFIX indicates where the action came from
 * @param {Function} dispatch
 * @param {Object} messages messages object containing copy
 */
const setAddToWishlistErrorNotification = (PREFIX, dispatch, messages) => {
    if (PREFIX === FETCH_NAVIGATION_PREFIX)
        return dispatch(
            notificationActions.setNotification({
                name: 'action',
                type: 'info',
                message: messages?.notifications?.authToAdd?.(),
            }),
        );
};

export const noUberTokenError = (uberToken, PREFIX, locale, additionalParams) => {
    return (dispatch, getState) => {
        if (!uberToken) {
            setAddToWishlistErrorNotification(PREFIX, dispatch, getMessages(getState()));
            dispatch({ type: NO_UBER_TOKEN_ERROR });
            dispatch({ type: `${PREFIX}/FAILURE`, body: NO_UBER_TOKEN_ERROR });
            // Wrapping the redirect within a setTimeout fixes the missing notification icon bug in Safari
            setTimeout(() => {
                redirectToLogin(locale, additionalParams);
            }, 0);
        }
    };
};

export function apiAuthenticatedRequest(request, PREFIX, locale, options = {}) {
    return (dispatch, getState) => {
        return dispatch(apiAction(request, PREFIX, null, options)).catch((error) => {
            if (error.status === 401 || error.status === 403) {
                setAddToWishlistErrorNotification(PREFIX, dispatch, getMessages(getState()));
                dispatch({ type: NOT_AUTHORISED_ERROR });
                redirectToLogin(locale, options?.redirectToLoginParams);
            }
            // TODO: remove this and fix the actions catching this error. This causes
            // an unhandled promise rejection warning.
            throw error;
        });
    };
}

export function apiAuthenticatedMultipleRequest(requests, locale) {
    return (dispatch) => {
        return dispatch(multipleRequestApiAction(requests, false)).catch((error) => {
            if (error.status === 401 || error.status === 403) {
                dispatch({ type: NOT_AUTHORISED_ERROR });
                redirectToLogin(locale);
            }
        });
    };
}
